module.exports = __webpack_public_path__ + "img/icon-needle.deb0d7b8.svg";